import { render, staticRenderFns } from "./edit-resource.vue?vue&type=template&id=28e578e0&scoped=true&"
import script from "./edit-resource.vue?vue&type=script&lang=ts&"
export * from "./edit-resource.vue?vue&type=script&lang=ts&"
import style0 from "./edit-resource.vue?vue&type=style&index=0&id=28e578e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e578e0",
  null
  
)

export default component.exports